import * as React from 'react';
import { mergeClasses } from '../constants';
import SortSpinner from './SortSpinner';

type Props = {
  children: React.ReactNode;
  className?: string;
  name: string;
  sort?: string;
  toggleSort?: (arg0: string) => void;
};

export default class SortableTableColumnHeader extends React.Component<Props> {
  setColumnToSort = () => {
    const { toggleSort, name } = this.props;
    if (toggleSort) {
      toggleSort(name);
    }
  };

  render() {
    const { children, className, name, sort, toggleSort, ...rest } = this.props;

    return (
      <th
        data-name={name}
        className={mergeClasses([
          'align-middle',
          className,
          toggleSort ? 'cursor-pointer' : '',
        ])}
        onClick={this.setColumnToSort}
        {...rest}
      >
        {children}{' '}
        {toggleSort && (
          <SortSpinner
            sort={(sort || '').replace(/^-?/, '') === name ? sort : ''}
          />
        )}
      </th>
    );
  }
}
